import { useInfiniteQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { EligibleStorageApiAdapter } from '../adapters/EligibleStorageApiAdapter';
import { BlockedStorage, EligibleStorageFilters } from '../models/EligibleStorage';

export const useBlockedStorages = (filters: EligibleStorageFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new EligibleStorageApiAdapter(httpClient);

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['blockedStorages', filters],
    queryFn: ({ pageParam = 1 }) =>
      apiAdapter.getBlockedStoragesPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 2 * 60 * 1000, // 2 minutos
    // 🎯 En React Query v5, usamos placeholderData para mantener los datos anteriores
    placeholderData: (previousData) => previousData,
  });

  const blockedStorages = data?.pages.flatMap((page) => page.blockedStorages) ?? [];
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    blockedStorages,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    totalPages: data?.pages.length ?? 0,
    totalLocations: blockedStorages.length,
    total: totalFromApi, // Total real del API (con filtros)
  };
};

